/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {

  function initStickyCart() {

    const productComponent = document.querySelector("product-component");

    if (!productComponent) return;

    const cartBar = productComponent.querySelector("#cart-bar");
    const formElement = productComponent.querySelector("[data-product-form]");

    if (!cartBar || !formElement) return;

    document.removeEventListener(
      "theme:scroll",
      productComponent.toggleCartBarOnScroll
    );

    let hasScrolled = false;

    function toggleCartBar() {

      // Don't show until user scrolls
      if (!hasScrolled) {
        cartBar.classList.remove("is-visible");
        return;
      }

      const rect = formElement.getBoundingClientRect();

      const shouldShow =
        window.scrollY > 100 &&
        rect.bottom < window.innerHeight * 1.6;

      cartBar.classList.toggle("is-visible", shouldShow);
    }

    function handleScroll() {
      hasScrolled = true;
      toggleCartBar();
    }

    // Hide initially
    cartBar.classList.remove("is-visible");

    window.addEventListener("scroll", handleScroll, {
      passive: true
    });

    window.addEventListener("touchmove", handleScroll, {
      passive: true
    });

    window.addEventListener("resize", toggleCartBar);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initStickyCart
    );
  } else {
    initStickyCart();
  }

})();